module.exports = require('./lib/type');



/*****************
 ** WEBPACK FOOTER
 ** ./~/chai/~/type-detect/index.js
 ** module id = 13
 ** module chunks = 1
 **/